import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCu6MDX4O_x7SmGO3x9RmL_zWHCRKWFQ1E",
  authDomain: "mjmotors-acf80.firebaseapp.com",
  projectId: "mjmotors-acf80",
  storageBucket: "mjmotors-acf80.firebasestorage.app",
  messagingSenderId: "214844385868",
  appId: "1:214844385868:web:cfc6dbb7009b57f29262e9"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

const shouldUseEmulators =
  process.env.NODE_ENV === 'development' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

if (shouldUseEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', {
    disableWarnings: true,
  });

  connectFirestoreEmulator(db, '127.0.0.1', 8081);
}
